import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<defs></defs><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><g id=\"alert-circle\"><path class=\"cls-1\" d=\"M11 22a11 11 0 1 1 11-11 11 11 0 0 1-11 11Zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-9Z\" id=\"Ellipse_17\" data-name=\"Ellipse 17\"></path><path class=\"cls-1\" d=\"M11 12a1 1 0 0 1-1-1V7a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1Z\" id=\"Line_5\" data-name=\"Line 5\"></path><path class=\"cls-1\" d=\"M11 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z\" id=\"Line_6\" data-name=\"Line 6\"></path></g></g></g>", 2)
  ]))]))
}
export default { render };